import { Injectable } from '@angular/core';

import { ToastMessagesServiceBase } from 'Angular/features/components/toast-messages/toast-messages-service-base';

/**
 * Service to manage creating and removing messages displayed by ToastMessagesComponent.
 */
@Injectable({
    providedIn: 'root',
})
export class PageToastMessagesService extends ToastMessagesServiceBase {}
